export default __webpack_public_path__ + "static/media/rest4.dd077688.png";